<template>
  <div id="app">
    <!-- <HeaderComp />
    <NavComp /> -->
    
    <FooterComp />
    <!-- <router-view /> -->
  </div>
</template>

<script>
export default {
  components: {
    //HeaderComp: () => import("./components/header.vue"),
    //NavComp: () => import("./components/navigation.vue"),
    FooterComp: () => import("./components/footer.vue"),
  },
  data: function () {
    return {};
  },
};
</script>

<style lang="scss" src="./scss/main.scss"></style>
